'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../tslib.es6-130a177d.js');
var React = require('react');
var styled = require('styled-components');
var typography_index = require('../typography/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var Wrapper = styled__default['default'].div.withConfig({ displayName: "ww-uikit_Wrapper_lty9a2wt", componentId: "sc-11lzyld" })(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    width: max-content;\n    position: relative;\n    ", "\n"], ["\n    width: max-content;\n    position: relative;\n    ", "\n"])), function (_a) {
    var $direction = _a.$direction;
    return ($direction !== 'right' ? "transform: rotate(180deg);" : "");
});
var Body = styled__default['default'].div.withConfig({ displayName: "ww-uikit_Body_lty9a2wt", componentId: "sc-7w9naz" })(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n    background: ", ";\n    min-width: 71px;\n    padding: 0px 12% 0px 6px;\n    height: 20px;\n    clip-path: polygon(100% 0, 92% 50%, 100% 100%, 0 100%, 0 0);\n    display: inline-block;\n"], ["\n    background: ", ";\n    min-width: 71px;\n    padding: 0px 12% 0px 6px;\n    height: 20px;\n    clip-path: polygon(100% 0, 92% 50%, 100% 100%, 0 100%, 0 0);\n    display: inline-block;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.turquoise100;
});
var BadgeText = styled__default['default'].div.withConfig({ displayName: "ww-uikit_BadgeText_lty9a2wt", componentId: "sc-38ja8z" })(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n    height: 20px;\n    display: grid;\n    place-items: center;\n    text-align: center;\n    width: 100%;\n    ", "\n    color: white;\n    white-space: nowrap;\n    ", "\n"], ["\n    height: 20px;\n    display: grid;\n    place-items: center;\n    text-align: center;\n    width: 100%;\n    ", "\n    color: white;\n    white-space: nowrap;\n    ", "\n"])), typography_index.caption2, function (_a) {
    var $direction = _a.$direction;
    return ($direction !== 'right' ? "transform: rotate(180deg);" : "");
});
var Triangle = styled__default['default'].div.withConfig({ displayName: "ww-uikit_Triangle_lty9a2wt", componentId: "sc-c5me9" })(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n    position: absolute;\n    left: 0px;\n    bottom: -4px;\n    clip-path: polygon(100% 0, 0 0, 100% 100%);\n    background: ", ";\n    height: 4px;\n    width: 6.5px;\n"], ["\n    position: absolute;\n    left: 0px;\n    bottom: -4px;\n    clip-path: polygon(100% 0, 0 0, 100% 100%);\n    background: ", ";\n    height: 4px;\n    width: 6.5px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.turquoise100;
});
var RecommendationBadge = function (props) {
    var text = props.text, direction = props.direction;
    return (React__default['default'].createElement(Wrapper, { "$direction": direction },
        React__default['default'].createElement(Body, null,
            React__default['default'].createElement(BadgeText, { "data-testid": "badge-text", "$direction": direction }, text)),
        React__default['default'].createElement(Triangle, null)));
};
RecommendationBadge.defaultProps = {
    text: 'Empfehlung',
    direction: 'right',
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

exports.default = RecommendationBadge;
//# sourceMappingURL=index.js.map
